import { Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';
import { Card } from '@/components/layout/Card/Card';

import { VERTICAL_SPACING } from '../../components/EducationalSlide.components';

export function EstateTaxesExplainer() {
  return (
    <Stack spacing={VERTICAL_SPACING}>
      <Card variant="filled" sx={{ p: 2 }}>
        <EditableRegion regionId="estate-taxes-intro" />
      </Card>

      <EditableRegion regionId="estate-taxes-section" />
    </Stack>
  );
}
